import React from "react";
import { css } from "aphrodite";
import { translate } from "../../../helper";
import { styles } from "../styles";
import { Delete } from "@mui/icons-material";
import { formatDate } from "../../../utils/CommonFunction";

export const LocationsColumnDetails = ({
  handleCancelSelectChild,
  handleSubscribeChild,
  handleResumeSubscribeChild,
  handleManage,
  setShowDeleteModal,
  setChildAccountId,
  setHasPendingOrders,
  canEditSubscription
}) => {
  const accountInfo = [
    {
      title: <span className={css(styles.tableHeader)}>{translate('location')}</span>,
      dataIndex: 'location',
      align: 'left',
      key: 'location',
      render: (_, row) => <span className={css(styles.tableBody)}>{row?.location_name || ''}</span>
    },
    {
      title: <span className={css(styles.tableHeader)}>{translate('adminEmail')}</span>,
      dataIndex: 'email',
      align: 'left',
      key: 'email',
      render: (_, row) => <span className={css(styles.tableBody)}>{row?.admin_email_1 || ''}</span>
    },
    {
      title: <span className={css(styles.tableHeader)}>{translate('adminName')}</span>,
      dataIndex: 'role',
      align: 'left',
      key: 'role',
      render: (_, row) => <span className={css(styles.tableBody)}>{row?.admin_name_1 || ''}</span>
    },
    {
      title: <span className={css(styles.tableHeader)}>{translate('dateCreated')}</span>,
      dataIndex: 'created_at',
      align: 'left',
      key: 'created_at',
      render: (_, row) => {
        return <span className={css(styles.tableBody)}>{row?.created_at ? formatDate(row?.created_at) : 'NA'}</span>
      }
    },
    {
      title: <div className={css(styles.tableCenteredHeader)}>{translate('actions')}</div>,
      dataIndex: '',
      align: 'center',
      key: 'actions',
      render: (_, row) => {
        let actionText = translate('cancelSubscription');
        let actionStyle = css(styles.actionTextCancel);
        let actionHandler = () => handleCancelSelectChild(row?.id);
    
        if (!row?.subscription) {
          actionText = translate('activateSubscription');
          actionStyle = css(styles.actionTextActivate);
          actionHandler = () => handleSubscribeChild(row);
        } else if (row?.subscription?.cancel_at_period_end) {
          actionText = translate('resumeSubscription');
          actionStyle = css(styles.actionTextResume);
          actionHandler = () => handleResumeSubscribeChild(row?.id);
        }
    
        return (
          <div className={css(styles.buttonContainer)}>
            <div
              className={css(styles.manageButton)}
              onClick={() => handleManage(row)}
            >
              {translate('manage')}
            </div>
              <span title={translate('deleteLocation')}  style={{display:'flex', alignItems:'center', cursor:'pointer', justifyContent:'center'}} onClick={() => {
                  setShowDeleteModal(true);
                  setChildAccountId(row?.id);
                  setHasPendingOrders(row?.is_pending_orders);
                }}>
                <Delete className={css(styles.deleteButton)} />
              </span>
          </div>
        );
      }
    }
    
  ].filter(Boolean);

  return canEditSubscription ? accountInfo : accountInfo.filter(col => col.key !== 'actions');
};

